module.exports = __webpack_public_path__ + "static/api-page-2-0f775b987b75b16ec23d4b908aa50951.png";